import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  generateQrCodeMutation: { message: string }
}

export type QrCodeFileFormat = 'PNG' | 'PDF' | 'JPG'

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.generateQrCodeMutation.message,
  name: 'QrCodeGeneration Message',
})

export interface QrCodeOptions {
  spaceIds: string[]
  floorIds: string[]
  generatorOptions: {
    fileFormat: QrCodeFileFormat
    size: string
    color: string
    type: string
    is_transparent: boolean
  }
}

export default function download(options: QrCodeOptions): Promise<string> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: options },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation GenerateQrCodeMutation($input: GenerateQrCodeMutationInput!) {
    generateQrCodeMutation(input: $input) {
      message
    }
  }
`
